import { useDispatch } from '@redux';
import {
  cancelOrderReturn,
  getByIdOrdersReturn,
} from '@redux/ordersReturn/actions';
import { Form, Input, Modal, Select } from 'antd';
import { CANCEL_REASON } from 'constants/ordersReturn';
import useToggleModal from 'hooks/useToogleModal';
import React, { useEffect, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CancelModal = ({ id, initValue }, ref) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { visible, toggleModal } = useToggleModal();
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => {
      toggleModal();
    },
  }));

  const handleValidation = async (values) => {
    setLoading(true);
    dispatch(cancelOrderReturn({ data: { id: id, data: values } }))
      .then(() => {
        dispatch(
          getByIdOrdersReturn({
            data: { id: id },
            options: { isRequestApi: true, isRefresh: true },
          }),
        ).finally(() => {
          setLoading(false);
          if (visible) toggleModal();
        });
      })
  };

  useEffect(() => {
    if (initValue) {
      form.setFieldsValue(initValue);
    }
  }, []);

  return (
    <Modal
      open={visible}
      title={t('ordersReturn.modal.cancel')}
      onCancel={() => visible && toggleModal()}
      onOk={() => form.submit()}
      width={462}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" onFinish={handleValidation}>
        <Form.Item
          name="cancelReason"
          label={t('ordersReturn.cancelReason.title')}
          rules={[{ required: true }]}
        >
          <Select placeholder="Select..." allowClear>
            {Object.values(CANCEL_REASON)?.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {t(item?.text)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="cancelNote"
          label={t('ordersReturn.cancelNote')}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.forwardRef(CancelModal);
